// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MenuDropdown_wrapper__uAhfp","columnGrid":"MenuDropdown_columnGrid__6UYML","bottomLink":"MenuDropdown_bottomLink__cFshJ","fadeIn":"MenuDropdown_fadeIn__0c7jG"};